"use strict";

var Search = function () {
  var after_completed = function () {
    if ((typeof LogisticsPosition !== typeof undefined) && (typeof LogisticsPosition.calculate_loading_rate === "function")) {
      LogisticsPosition.calculate_loading_rate();
    }
  };

  return {
    run_search_callbacks: function() {
      after_completed();
    }
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Search;
}
